//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import axios from 'axios';
import australiaImage from 'images/australia_icon.png';
import chinaImage from 'images/china_icon.png';

export default {
  data: function () {
    return {
      englishSite: '',
      chineseSite: '',
      currentUrl: '',
      checkRedirect: '',
      australiaImage: australiaImage,
      chinaImage: chinaImage,
      isChineseSite: false,
      isEnglishSite: true
    };
  },
  mounted: function () {
    this.initLanguageOptions().then(() => {
      const languagePreference = this.getLanguagePreference();
      const urlParams = new URLSearchParams(window.location.search);
      const languageRedirect = urlParams.get('language_redirect');

      // If the user has been redirected, update the local storage reference
      if (languageRedirect) {
        this.saveLanguagePreference(languageRedirect);
      }

      // If there is no language preference, or the user has been redirected, then do nothing
      if (!languagePreference || languageRedirect) {
        return;
      }

      // Otherwise, if there is a valid languagePreference, redirect the user
      this.redirectAsPreference();
    });
  },
  methods: {
    redirectAsPreference: function () {
      const languagePreference = this.getLanguagePreference();

      if (languagePreference === 'english' && !this.isEnglishSite) {
        // redirect to the english site
        window.location.href = `${this.englishSite}?language_redirect=chinese`;
      }

      if (languagePreference === 'chinese' && !this.chineseSite) {
        // redirect to the chinese site
        window.location.href = `${this.chineseSite}?language_redirect=chinese`;
      }
    },
    initLanguageOptions: function () {
      return axios
        .get('/wp-json/costimise/site-language')
        .then((response) => response.data)
        .then((data) => {
          this.englishSite = data.site_language.site_english;
          this.chineseSite = data.site_language.site_chinese;

          const { hostname } = new URL(window.location.href);
          const { hostname: englishSiteHost } = new URL(this.englishSite);
          const { hostname: chineseSiteHost } = new URL(this.chineseSite);

          this.isEnglishSite = englishSiteHost === hostname;
          this.isChineseSite = chineseSiteHost === hostname;
        });
    },
    saveLanguagePreference: function (languagePreference) {
      if (
        languagePreference !== 'chinese' &&
        languagePreference !== 'english'
      ) {
        return;
      }

      window.localStorage.setItem('languagePreference', languagePreference);
    },
    getLanguagePreference: function () {
      return window.localStorage.getItem('languagePreference');
    },
    showEnglishSite: function () {
      this.saveLanguagePreference('english');
      window.location.href = `${this.englishSite}?language_redirect=english`;
    },
    showChineseSite: function () {
      this.saveLanguagePreference('chinese');
      window.location.href = `${this.chineseSite}?language_redirect=chinese`;
    }
  },
  computed: {
    // a computed getter
    currentLanguage: function () {
      console.log('Is chinese site', this.isChineseSite);
      return this.isChineseSite
        ? {
            label: '简体中文',
            flag: chinaImage,
            onClick: this.showChineseSite
          }
        : {
            label: 'English (UK)',
            onClick: this.showEnglishSite,
            flag: australiaImage
          };
    },
    languageOption: function () {
      return this.isChineseSite
        ? {
            label: 'English (UK)',
            onClick: this.showEnglishSite,
            flag: australiaImage
          }
        : {
            label: '简体中文',
            flag: chinaImage,
            onClick: this.showChineseSite
          };
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/vue/site-language/SiteLanguage.vue